import React, { useRef, useState, useEffect, useCallback } from 'react';
import {
  TextField,
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Title,
  useListContext,
  ListContextProvider,
  Datagrid,
} from 'react-admin';

import { makeStyles, Card, Divider, Tabs, Tab } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ClearIcon from '@material-ui/icons/Clear';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import { DialogoConfirmacao } from '../../Components';
import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { api } from '../../services';
import { STATUS_ATIVO, STATUS_INATIVO } from '../../utils/constants';
//import ActionsField from './ActionsField';
import { PERMISSAO_TELA_CATEGORIAS_PROBLEMAS_LISTAR } from '../../utils/dadosTelas';
import DialogoCreate from './DialogoCreate';
import Filter from './Filter';
import StatusField from './StatusField';

const tabs = [
  { id: 'ativos', name: 'Ativos' },
  { id: 'inativos', name: 'Inativos' },
];

const useStylesDatagrid = makeStyles((theme) => ({
  dataHeader: {
    // marginLeft: '30px',
    // backgroundColor: 'red',
    flex: 1,
    backgroundColor: '#f8f8f8',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    // marginLeft: '30px',
    // backgroundColor: 'red',
    flex: 1,
    // backgroundColor: '#f8f8f8',
    padding: '10px',
    // color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    // borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

//
const MyList = ({ ...props }) => {
  const classes = useStylesDatagrid();
  const refDialogoCreate = useRef(null);
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  const [ativos, setAtivos] = useState([]);
  const [inativos, setInativos] = useState([]);
  const refDialogoConfirmacao = useRef(null);
  const refresh = useRefresh();

  function handleAtivar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Reativação de Categoria de problemas de despesa',
        'Deseja realmente reativar este categoria de problemas de despesa?',
        { id, codigo: 1 },
      );
    }
  }

  function handleDesativar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Desativação de Categoria de problemas de despesa',
        'Deseja realmente desativar este categoria de problemas de despesa?',
        { id, codigo: 2 },
      );
    }
  }

  function handleDeletar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Exclusão de Categoria de problemas de despesa',
        'Deseja deletar permanentemente esta categoria de problemas de despesa?',
        { id, codigo: 3 },
      );
    }
  }

  function handleCriar() {
    if (refDialogoCreate.current) {
      refDialogoCreate.current.handleCreate();
    }
  }
  function handleEdit({ id }) {
    if (refDialogoCreate.current) {
      refDialogoCreate.current.handleEdit(id);
    }
  }

  async function ativar(id) {
    await api.put(`/categorias-problemas-despesas/status/ativar/${id}`);
    handleClose();
  }

  async function desativar(id) {
    await api.put(`/categorias-problemas-despesas/status/inativar/${id}`);
    handleClose();
  }

  async function deletar(id) {
    await api.put(`/categorias-problemas-despesas/status/deletar/${id}`);
    handleClose();
  }

  async function handleConfirma({ id, codigo }) {
    switch (codigo) {
      case 1:
        ativar(id);
        break;
      case 2:
        desativar(id);
        break;
      case 3:
        deletar(id);
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    if (ids && ids !== filterValues.status) {
      switch (filterValues.status) {
        case STATUS_ATIVO:
          setAtivos(ids);
          break;
        case STATUS_INATIVO:
          setInativos(ids);
          break;
        default:
          break;
      }
    }
  }, [ids, filterValues.status]);

  const handleChange = useCallback(
    (event, value) => {
      if (setFilters) {
        setFilters(
          {
            ...filterValues,
            status: value === 'ativos' ? STATUS_ATIVO : STATUS_INATIVO,
          },
          displayedFilters,
        );
      }
    },
    [displayedFilters, filterValues, setFilters],
  );

  const handleClose = () => {
    refresh();
  };

  return (
    <>
      <Title title="Categorias Problemas de Despesas" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px', marginTop: '30px' }} {...props}>
        <Divider />
        <Tabs
          variant="fullWidth"
          centered
          value={filterValues.status === STATUS_ATIVO ? tabs[0].id : tabs[1].id}
          indicatorColor="primary"
          onChange={handleChange}
        >
          {tabs.map((choice) => (
            <Tab key={choice.id} label={choice.name} value={choice.id} />
          ))}
        </Tabs>
        <Divider />
        <div>
          {filterValues.status === STATUS_ATIVO && (
            <ListContextProvider value={{ ...listContext, ids: ativos }}>
              <Datagrid {...props} bulkActionButtons={false}>
                <TextField
                  source="nome"
                  label="Descrição"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <StatusField
                  source="incluir_documento_boleto"
                  label="Obrigar Inlusão do Boleto"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <ActionsField
                  source="valor"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  /* handleEdit={handleEdit}
                  handleAtivar={handleAtivar}
                  handleDesativar={handleDesativar}
                  handleDeletar={handleDeletar} */
                  actions={[
                    {
                      key: 'editar',
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      onClick: (rec) => handleEdit(rec),
                      show: (rec) => rec.status === STATUS_ATIVO,
                      disabled: (rec) => !rec.pode_atualizar,
                    },
                    {
                      key: 'ativar',
                      title: 'Ativar',
                      icon: <CheckCircleOutlineIcon />,
                      onClick: (rec) => handleAtivar(rec),
                      show: (rec) => rec.status === STATUS_INATIVO,
                      disabled: (rec) => !rec.pode_deletar,
                    },
                    {
                      key: 'desativar',
                      title: 'Desativar',
                      icon: <ClearIcon />,
                      onClick: (rec) => handleDesativar(rec),
                      show: (rec) => rec.status === STATUS_ATIVO,
                      disabled: (rec) => !rec.pode_deletar,
                    },
                    {
                      key: 'excluir',
                      title: 'Excluir',
                      icon: <DeleteOutlineIcon />,
                      onClick: (rec) => handleDeletar(rec),
                      show: (rec) => rec.status === STATUS_INATIVO,
                      disabled: (rec) => !rec.pode_deletar,
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.status === STATUS_INATIVO && (
            <ListContextProvider value={{ ...listContext, ids: inativos }}>
              <Datagrid {...props} bulkActionButtons={false}>
                <TextField
                  source="nome"
                  label="Descrição"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <StatusField
                  source="incluir_documento_boleto"
                  label="Obrigar Inlusão do Boleto/Pix"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <ActionsField
                  source="valor"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  /* handleEdit={handleEdit}
                  handleAtivar={handleAtivar}
                  handleDesativar={handleDesativar}
                  handleDeletar={handleDeletar} */
                  actions={[
                    {
                      key: 'editar',
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      onClick: (rec) => handleEdit(rec),
                      show: (rec) => rec.status === STATUS_ATIVO,
                      disabled: (rec) => !rec.pode_atualizar,
                    },
                    {
                      key: 'ativar',
                      title: 'Ativar',
                      icon: <CheckCircleOutlineIcon />,
                      onClick: (rec) => handleAtivar(rec),
                      show: (rec) => rec.status === STATUS_INATIVO,
                      disabled: (rec) => !rec.pode_deletar,
                    },
                    {
                      key: 'desativar',
                      title: 'Desativar',
                      icon: <ClearIcon />,
                      onClick: (rec) => handleDesativar(rec),
                      show: (rec) => rec.status === STATUS_ATIVO,
                      disabled: (rec) => !rec.pode_deletar,
                    },
                    {
                      key: 'excluir',
                      title: 'Excluir',
                      icon: <DeleteOutlineIcon />,
                      onClick: (rec) => handleDeletar(rec),
                      show: (rec) => rec.status === STATUS_INATIVO,
                      disabled: (rec) => !rec.pode_deletar,
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
        </div>
        <TransacoesPagination />
      </Card>
      <DialogoCreate
        ref={refDialogoCreate}
        handleClose={() => {
          refresh();
        }}
      />
      <DialogoConfirmacao
        ref={refDialogoConfirmacao}
        handleConfirma={handleConfirma}
      />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_CATEGORIAS_PROBLEMAS_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Categorias Problemas de Despesas"
      filterDefaultValues={{
        status: STATUS_ATIVO,
      }}
    />
  </ProtegerPagina>
);

export default List2;
